'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var react = require('@chakra-ui/react');
var utils = require('@chakra-ui/utils');
var React = require('react');
var alertContext = require('./alertContext.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var _excluded = ["status", "addRole"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty__default["default"](target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
/**
 * Alert is used to communicate the state or status of a
 * page, feature or action
 *
 * @see Docs https://chakra-ui.com/docs/components/alert
 * @see WAI-ARIA https://www.w3.org/WAI/ARIA/apg/patterns/alert/
 */
var Alert = react.forwardRef(function Alert(props, ref) {
  var _props$colorScheme;
  var _omitThemingProps = react.omitThemingProps(props),
    _omitThemingProps$sta = _omitThemingProps.status,
    status = _omitThemingProps$sta === void 0 ? 'info' : _omitThemingProps$sta,
    _omitThemingProps$add = _omitThemingProps.addRole,
    addRole = _omitThemingProps$add === void 0 ? true : _omitThemingProps$add,
    rest = _objectWithoutProperties__default["default"](_omitThemingProps, _excluded);
  var colorScheme = (_props$colorScheme = props.colorScheme) !== null && _props$colorScheme !== void 0 ? _props$colorScheme : alertContext.getStatusColorScheme(status);
  var styles = react.useMultiStyleConfig('Alert', _objectSpread(_objectSpread({}, props), {}, {
    colorScheme: colorScheme
  }));
  var alertStyles = _objectSpread({
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    overflow: 'hidden'
  }, styles.container);
  return /*#__PURE__*/React__default["default"].createElement(alertContext.AlertProvider, {
    value: {
      status: status
    }
  }, /*#__PURE__*/React__default["default"].createElement(alertContext.AlertStylesProvider, {
    value: styles
  }, /*#__PURE__*/React__default["default"].createElement(react.chakra.div, _extends__default["default"]({
    role: addRole ? 'alert' : undefined,
    ref: ref
  }, rest, {
    className: utils.cx('chakra-alert', props.className),
    __css: alertStyles
  }))));
});
Alert.displayName = 'Alert';
exports.Alert = Alert;